import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Image';
import create from './create';
import edit from './edit';
import list from './list';

const posts: ResourceProps = {
  name: 'slides',
  icon,
  options: { label: 'Slides' },
  create,
  edit,
  list
};

export default posts;
